module.exports = "/assets/data/062645d2cd68738bc6f5dab2fc530294-BR2.data.json";